module.exports = {
  articlesPerPage: 8,
}
